
import React from "react";
import { AspectRatio } from "@/components/ui/aspect-ratio";

export const ColorGuideSection = () => (
  <div className="grid grid-cols-3 gap-2">
    <div className="flex items-center gap-1">
      <div className="relative w-6 min-w-[24px]">
        <AspectRatio ratio={1/1}>
          <div className="absolute inset-0 bg-success rounded flex items-center justify-center text-white font-bold text-xs">A</div>
        </AspectRatio>
      </div>
      <span className="text-gray-300 text-xs">Correct spot</span>
    </div>
    <div className="flex items-center gap-1">
      <div className="relative w-6 min-w-[24px]">
        <AspectRatio ratio={1/1}>
          <div className="absolute inset-0 bg-warning rounded flex items-center justify-center text-white font-bold text-xs">B</div>
        </AspectRatio>
      </div>
      <span className="text-gray-300 text-xs">Wrong spot</span>
    </div>
    <div className="flex items-center gap-1">
      <div className="relative w-6 min-w-[24px]">
        <AspectRatio ratio={1/1}>
          <div className="absolute inset-0 bg-gray-900 border border-gray-600 rounded flex items-center justify-center text-white font-bold text-xs">C</div>
        </AspectRatio>
      </div>
      <span className="text-gray-300 text-xs">Not in word</span>
    </div>
  </div>
);
